import React, {useState, useRef, useEffect} from "react";
import assets from "../assets/imgs";
import Pagination from "./Pagination";
import TableHeaderSet from "./TableHeaderSet";

function MainTable({title, tableHeadTitles, tableData, style, checkable, onActionMenuClick, actionMenuItems, boardTypeList,
  pageType, performanceType, boardRowClick, dateFilterBase, setUpperData, mainSearchKey = ""
}) {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedBoardType, setSelectedBoardType] = useState(null);
  const [currentPage, setCurrentPage] = useState(1); // 현재 페이지 상태
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedDateRange, setSelectedDateRange] = useState(null);
  const [filteredData, setFilteredData] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [menuPosition, setMenuPosition] = useState({top: 0, left: 0});
  const [sumData, setSumData] = useState([]);

  //더보기 메뉴쪽
  const [isMenuVisible, setMenuVisible] = useState(false);
  const [activeRow, setActiveRow] = useState(null);
  const menuRef = useRef(null);

  const pageTypeList ={
    board : "board", performance: "performance", commute: "commute", mypage: "mypage"
  };
  const performanceTypeList = {
    sales : 'sales', intellectual: 'intellectualProperties', invest: 'invests', 
    prize: 'prizes', support: 'supportProjects', team: 'employments'
  }

  const menuTargetRef = useRef(null);
  
  const handleMenuToggle = (event, rowId) => {
    setActiveRow(rowId === activeRow ? null : rowId);
    setMenuVisible(rowId === activeRow ? false : true);

    if (event) {
      const rect = event.target.getBoundingClientRect(); // 클릭된 요소 위치
      menuTargetRef.current = event.target; // 클릭된 요소 저장
      const menuHeight = menuRef.current?.offsetHeight || 315; // 기본값 225
      console.log('menuHeight: ', menuRef.current?.offsetHeight);
      const topPosition = (rect.bottom + menuHeight > window.innerHeight)  ? rect.bottom - menuHeight - 35 : rect.bottom + 10;

      setMenuPosition({
          top: topPosition, // 
          left: rect.left - 150,
      });
    }
  };

  //스크롤 영향
  useEffect(() => {
    const handleScroll = () => {
      if (activeRow && menuTargetRef.current) {
        const rect = menuTargetRef.current.getBoundingClientRect();
        const menuHeight = menuRef.current?.offsetHeight || 315; // 기본값 225

        const topPosition = (rect.bottom + menuHeight > window.innerHeight)  ? rect.bottom - menuHeight - 35 : rect.bottom + 10;

        setMenuPosition({
            top: topPosition, // 항상 요소 위치 기준으로 갱신
            left: rect.left - 150,
        });
      }
    };
  
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [activeRow]);
  
  const handleMenuToggle0Length = (rowId) =>{
    onActionMenuClick("default", rowId);
  }

  // 메뉴 외부 클릭 감지
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuVisible(false);
        setActiveRow(null);
      }
    };

    if (isMenuVisible) {
      document.addEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isMenuVisible]);
  //메뉴 끝

  const authorityMap =new Map([
    [1, "가입 대기"],
    [2, "입주사 팀원"],
    [3, "대표 권한"],
    [4, "입주사 대표"],
    [5, "캠퍼스타운"],
    [6, "캠퍼스타운 관리자"],
    [7, "최고 관리자"],
  ]);

  let itemsPerPage = 15; // 페이지당 항목 수
  if(pageType === pageTypeList.commute){
    itemsPerPage = 10;
  }

  const defaultHeadTitles = [
    { key: 'id', label: '순번' },
    { key: 'date', label: '날짜' },
    { key: 'team', label: '팀명' },
    { key: 'client', label: '거래처' },
    { key: 'clientNumber', label: '거래처 사업자번호' },
    { key: 'clientName', label: '거래처명' },
    { key: 'amount', label: '거래금액' },
    { key: 'etc', label: '기타' },
  ];

  const defaultData = [];

  const keysForCurrency = ['amount'];

  const addCurrencyUnit = (data, keysToFormat) => {
    return data.map((row) => {
      const updatedRow = { ...row };
  
      keysToFormat.forEach((key) => {
        if (updatedRow[key] !== undefined && updatedRow[key] !== null) {
          const numericValue =
            typeof updatedRow[key] === 'number'
              ? updatedRow[key]
              : Number(updatedRow[key].toString().replace(/,/g, ''));
          updatedRow[key] =
            new Intl.NumberFormat('ko-KR').format(numericValue) + ' 원';
        }
      });
  
      return updatedRow;
    });
  };
  const changeToCurrency = (value, key) =>{
    if (!keysForCurrency.includes(key)) return value; // 변환 대상이 아니면 그대로 반환
    console.log(typeof value !== 'number' || isNaN(value));
    if (value !== undefined && value !== null){
      const numericValue =
        typeof value === 'number'
          ? value
          : Number(value.toString().replace(/,/g, ''));
      return new Intl.NumberFormat('ko-KR').format(numericValue) + ' 원';
    }
    return value;
    // if (typeof value !== 'number' || isNaN(value)) return '-'; // 숫자가 아니면 표시 생략
    // return new Intl.NumberFormat('ko-KR').format(value) + ' 원';
  }
  
  // 헤드라인과 데이터 확인
  const currentHeadTitles = tableHeadTitles && tableHeadTitles.length > 0 ? tableHeadTitles : defaultHeadTitles;
  const currentData = (tableData && tableData.length > 0) ? 
    // addCurrencyUnit(tableData, keysForCurrency) 
    tableData
    : defaultData;

  // console.log('table data is :', currentData);
 
  // const [filteredData, setFilteredData] = useState(currentData);

  
  // 현재 페이지에 표시할 항목 계산
  const startIndex = (currentPage - 1) * itemsPerPage;
  const items = filteredData.slice(startIndex, startIndex + itemsPerPage);

  // 총 페이지 수 계산
  // setTotalPages(Math.ceil(filteredData.length / itemsPerPage));
  useEffect(() => {
    console.log('table on');
    if(tableData && tableData.length > 0){
      setFilteredData(currentData);
      setSelectedBoardType('all');
      // Initialize total pages when component mounts
      setTotalPages(Math.ceil(currentData.length / itemsPerPage));
      console.log('total pages: ', Math.ceil(currentData.length / itemsPerPage));
    }
  }, [tableData]);

  useEffect(() => {
    if (typeof setUpperData === 'function') {
      setUpperData(filteredData);
    }
    if(pageType == pageTypeList.performance){
      updateSumData();
    }
  }, [filteredData]);

  const updateSumData = () =>{
    let numOfContents = `총: ${filteredData.length}`;
    let sumValue = `합계 : ${changeToCurrency(filteredData.reduce((total, row) => {
      if (!Object.prototype.hasOwnProperty.call(row, 'amount')) return total;
    
      let amount = row.amount;
      if (typeof amount === 'string') {
        amount = Number(amount.replace(/[^0-9.-]/g, ''));
      }
      const returnValue = total + (typeof amount === 'number' && !isNaN(amount) ? amount : 0);

      return returnValue;
    }, 0), 'amount')}`;
  
    // let sumValue;
    let formatted = {id: numOfContents, amount: sumValue};

    switch(performanceType){
      case performanceTypeList.sales:
        break;
      case performanceTypeList.intellectual:
        {
          const typeList = [ '특허', '상표', '실용신안', '디자인', '기타'];
          const statusList = [ '출원', '등록' ]; 

          const grouped = {};
          typeList.forEach(type => {
            grouped[type] = {};
            statusList.forEach(status => {
              grouped[type][status] = 0;
            });
          });

          filteredData.forEach(row => {
            const type = row.type || '기타';
            const status = row.status || '기타';

            // 예외: 정의되지 않은 타입이 나오면 추가
            if (!grouped[type]) {
              grouped[type] = {};
              statusList.forEach(s => grouped[type][s] = 0);
            }

            if (!grouped[type][status]) {
              grouped[type][status] = 0;
            }

            grouped[type][status] += 1;
          });

          const countSummary = typeList.map(type => {
            const statusMap = grouped[type];
            const statuses = statusList.map(status => `${status}: ${statusMap[status]}건`).join(', ');
            const line = `${type}(${statuses})`;
            return (type === '상표') ? `${line}<br />` : line;
          }).join(' / ');
          
          sumValue = countSummary;
          formatted = {id: numOfContents, name: sumValue};
          break;
        }        
      case performanceTypeList.invest:
        break;
      case performanceTypeList.prize:
        break;
      case performanceTypeList.support:
        break;
      case performanceTypeList.team:
        {
          let workingCount = 0;
          let maleCount = 0;
          let femaleCount = 0;

          filteredData.forEach(row => {
            // console.log(row.hire_date, row.quit_date);
            let isWorking = false;
            if(selectedDate === null){
              isWorking = row.hire_date && (row.quit_date === '알 수 없음');
            }else{
              isWorking = row.hire_date;
            }

            if (isWorking) {
              workingCount += 1;

              if (row.sex === '남') maleCount += 1;
              else if (row.sex === '여') femaleCount += 1;
            }
          });
          const preWord = (selectedDate === null) ? '재직 중' : '당월 고용';

          const summary = `${preWord}<br /> 남: ${maleCount}명, 여: ${femaleCount}명`;
          sumValue = summary;
          formatted = { id: `총원 ${workingCount}명`, name: summary };
          break;
        }
        
      default:
        break;
    }
    // const formatted = {id: numOfContents, amount: sumValue};
    setSumData(formatted);
  }


  const handleDateSelect = (formattedDate) => {
    // console.log("formattedDate:", formattedDate);

    const [year, month] = formattedDate.split('-');
    const startDate = new Date(year, month - 1, 1); // First day of the month
    const endDate = new Date(year, month, 0); // Last day of the month

    // console.log("Filtering data for:", startDate, endDate);


    const filtered = currentData.filter((d) => {
      const raw = d[dateFilterBase ?? 'date'];
      const [y, m, day] = raw.split('-').map(Number);
      const date = new Date(y, m - 1, day); // ✅ timezone-safe

      return date >= startDate && date <= endDate;
      // const date = new Date(d[dateFilterBase ?? 'date']);
      // return date >= startDate && date <= endDate;
    });

    // console.log("Filtered data:", filtered);


    setSelectedDateRange({ startDate, endDate });
    setSelectedDate(formattedDate);
    setFilteredData(filtered);
    setCurrentPage(1);
    setTotalPages(Math.max(Math.ceil(filtered.length / itemsPerPage), 1));
  };

  // console.log(selectedDateRange)
  // console.log('out data:', filteredData);

  const handleBoardTypeSelect = (key) => {
    setSelectedBoardType(key);
    const filtered = currentData.filter((d) => {
      //all 인 경우
      if(key === 'all') return true;
      //category가 select 되었을시
      return d.boardNetworkCategory === key;
    });
    setFilteredData(filtered);
    setCurrentPage(1);
    setTotalPages(Math.max(Math.ceil(filtered.length / itemsPerPage), 1));
  };

  const handleBoardContentsClick = (_id) =>{
    boardRowClick(_id);
  }

  const handleCategorySelect = (key) => {
    setSelectedCategory(key);
  };

  const handleSearch = ()=>{
    if(searchTerm === ""){
      alert('검색어를 입력해 주세요.');
      return null;
    }
    const matchedAuthorityKeys = Array.from(authorityMap.entries())
      .filter(([_, label]) => {
        const lowerLabel = label.toLowerCase();
        const lowerSearch = searchTerm.toLowerCase();
        // console.log("비교 중:", lowerLabel, "vs", lowerSearch, lowerLabel.includes(lowerSearch));
        return lowerLabel.includes(lowerSearch);
      })
      .map(([key]) => key); // 해당 label의 key 목록

    const matchedBoardNetworkingTypeKeys = (boardTypeList || [])
      .filter(item =>
        item.label.toLowerCase().includes(searchTerm.toLowerCase())
      )
      .map(item => item.key);

    const filtered = currentData.filter((d) => {      
      if(mainSearchKey === ""){
        return null;
      }
      //아무것도 선택안된 경우
      console.log('search', d[mainSearchKey], searchTerm);
      if(selectedCategory === null){
        return d[mainSearchKey].toLowerCase().includes(searchTerm.toLowerCase());
      }else{
        if(selectedCategory === "authority"){        
          return matchedAuthorityKeys.includes(d[selectedCategory]);
        }else if(selectedCategory === "boardNetworkCategory"){
          return matchedBoardNetworkingTypeKeys.includes(d[selectedCategory]);
        }else{
          return d[selectedCategory].toLowerCase().includes(searchTerm.toLowerCase());
        }
      }
    });
    setFilteredData(filtered);
    setCurrentPage(1);
    setTotalPages(Math.max(Math.ceil(filtered.length / itemsPerPage), 1));
  }

  return (
    <div className="commonComponent" style={{ padding: "12px", margin: "16px", position: "relative", flex: 1, ...style,}}> 
      {(() =>{
        switch(pageType){
          case pageTypeList.mypage:
            return <TableHeaderSet.MyPageHeader headTitle={title} searchTerm={searchTerm} setSearchTerm={setSearchTerm} 
              dataNumber={filteredData.length} handleCategorySelect={handleCategorySelect} selectedCategory={selectedCategory}
              tableTitles={currentHeadTitles} handleSearch={handleSearch}/>
          case pageTypeList.commute:
            return <TableHeaderSet.CommuteHeader searchTerm={searchTerm} setSearchTerm ={setSearchTerm} handleSearch={handleSearch}
              tableTitles={currentHeadTitles}
            />;
          case pageTypeList.performance :
            return <TableHeaderSet.PerformanceHeader
              headTitle={title} tableTitles={currentHeadTitles}
              searchTerm={searchTerm} setSearchTerm={setSearchTerm}
              handleCategorySelect={handleCategorySelect} selectedCategory={selectedCategory}
              handleDateSelect={handleDateSelect} selectedDate={selectedDate}
              dataNumber={filteredData.length} handleSearch={handleSearch}
            />;
          case pageTypeList.board :
            return <TableHeaderSet.BoardHeader 
              headTitle={title} searchTerm={searchTerm} setSearchTerm={setSearchTerm}
              boardTypeList={boardTypeList} selectedBoardType={selectedBoardType} handleBoardTypeSelect={handleBoardTypeSelect}
              dataNumber={filteredData.length} handleSearch={handleSearch} 
              handleCategorySelect={handleCategorySelect} selectedCategory={selectedCategory}
              tableTitles={currentHeadTitles}
            />;
          default:
            return <TableHeaderSet.PerformanceHeader />;
        }
      })()
      }      
      
      <table border="1" style={styles.mainTable}>
        <thead>
          <tr>
            {currentHeadTitles.map((head, colIndex) => (
              <th key={colIndex} style={{...styles.mainTableHead, ...cellWidthStyler(head.key)}}
                className={head.key === 'id' ? 'font-body3-semibold' : `font-body4-semibold`}>
                {head.label}
              </th>
            ))}
            {actionMenuItems && 
              <th style={{...styles.mainTableHead, width: "70px"}} className="font-body4-semibold">
                설정
              </th>
            }  
          </tr>
        </thead>
        <tbody>
          {/* 합계줄 */}
          {sumData && Object.keys(sumData).length > 0 && (
            <tr style={{ backgroundColor: "var(--grayscale_10)" }}>
              {currentHeadTitles.map((head, colIndex) => (
                <td 
                  key={colIndex}
                  style={{ ...styles.mainTableContents, ...cellWidthStyler(head.key), fontWeight: "bold" }}
                  className="font-body4-semibold"
                  dangerouslySetInnerHTML={{ __html: (sumData[head.key] ?? '').toString() }}
                >
                  {/* {(() => {
                    // if (colIndex === 0) return "합계";
                    const value = sumData[head.key];
                    // if (typeof value === "number") {
                    //   return value.toLocaleString(); // 숫자는 콤마 표시
                    // }
                    return value ?? '';
                  })()} */}
                </td>
              ))}
              {actionMenuItems && (
                <td style={{...styles.mainTableContents}}></td> // 설정 열 비워두기
              )}
            </tr>
          )}
          {items
            .map((row, rowIndex) => (
              <tr key={rowIndex} onClick={(pageType == pageTypeList.board) ? () => handleBoardContentsClick(row._id) : undefined}
                style={{cursor: (pageType === pageTypeList.board) ? "pointer" : "default"}}>
                {currentHeadTitles.map((head, colIndex) => (
                  <td 
                    key={colIndex} 
                    style={{...styles.mainTableContents, ...cellWidthStyler(head.key)}}
                    className={colIndex === 0 ? 'font-body3-semibold' : `font-body4-regular`}
                    >
                    {(() => {
                      switch (head.key) {
                        case 'boardNetworkCategory':
                          return (
                            <BoardTypeBadge
                              boardTypeKey={row[head.key]}
                              boardTypeList={boardTypeList}
                              />
                          );
                        case 'check':
                          return (<input type="checkbox" style={{cursor: "pointer"}} />);

                        case 'commute_alarm':
                          return (
                            // <div></div>
                          <CommuteAlarmBox rowId={row._id} readyState={row[head.key]}/>
                        );

                        case 'authority':
                          return authorityMap.get(row[head.key]) || "알수 없음";

                        default:
                          return changeToCurrency(row[head.key], head.key) ?? '-';
                          // return row[head.key] ?? '-';
                      }
                    })()}
                  </td>
                ))}
                {/* 메타볼 섹션 */}
                {actionMenuItems &&
                  (()=>{
                    if(pageType == pageTypeList.performance || pageType == pageTypeList.mypage){
                      return (
                        <td style={{...styles.mainTableContents, cursor:"pointer", position:"relative", display:"flex", justifyContent:"center", alignItems: "center"}} 
                          data-rowid={row._id}
                          onClick={(event) => {
                              (actionMenuItems && actionMenuItems.length === 0) ? handleMenuToggle0Length(row._id) : handleMenuToggle(event, row._id)                      
                            }}>
                          <div style={{background: "var(--grayscale-cool_20)", borderRadius: "6px", width: "24px", height: "24px"}}>
                            <assets.icons.meta_ball style={{color:"black"}}/>
                          </div>    
                          {isMenuVisible && activeRow === row._id && (
                            <ul ref={menuRef} style={{...styles.metaBallMenu, 
                              top: menuPosition.top,
                              left: menuPosition.left,
                              }} >
                              {actionMenuItems.map((item) => (
                                <li key={item.label} style={{...styles.metaBallMenuItem, ...item.style}} className="font-body3-semibold" onClick={() => onActionMenuClick(item.key, row)}>
                                  {item.icon}
                                  {item.label}
                                </li>
                              ))}
                            </ul>
                          )}            
                        </td>
                      );
                    }else{
                      return(<div></div>);
                    }
                    // switch(pageType){
                    //   case pageTypeList.performance:
                    //     return (
                    //       <td style={{...styles.mainTableContents, cursor:"pointer", position:"relative", display:"flex", justifyContent:"center", alignItems: "center"}} 
                    //         onClick={() => {
                    //             (actionMenuItems && actionMenuItems.length === 0) ? handleMenuToggle0Length(row) : handleMenuToggle(row._id)                      
                    //           }}>
                    //         <div style={{background: "var(--grayscale-cool_20)", borderRadius: "6px", width: "24px", height: "24px"}}>
                    //           <assets.icons.meta_ball style={{color:"black"}}/>
                    //         </div>
                    //         {isMenuVisible && activeRow === row._id && (
                    //           <ul ref={menuRef} style={styles.metaBallMenu} >
                    //             {actionMenuItems.map((item) => (
                    //               <li key={item.label} style={{...styles.metaBallMenuItem, ...item.style}} className="font-body3-semibold" onClick={() => onActionMenuClick(item.key, row)}>
                    //                 {item.icon}
                    //                 {item.label}
                    //               </li>
                    //             ))}
                    //           </ul>
                    //         )}
                    //       </td>
                    //     );
                    //   default:
                    //     return;
                    // }
                  })()
                }
              </tr>
            ))}
        </tbody>
      </table>      

      <Pagination 
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={setCurrentPage}
        style= {{position: "absolute",
          bottom: "12px",
          left: "50%",
          transform: "translateX(-50%)",}}
      />
    </div>
  );
}


// function DateFilterButton({onSelectDate, selectedDate }){
//   const [isPopupVisible, setPopupVisible] = useState(false);
//   const [year, setYear] = useState(new Date().getFullYear()); // Default to current year
//   const buttonRef = useRef();
//   const popupRef = useRef(); // Ref for the popup container

//   const togglePopup = () => setPopupVisible(!isPopupVisible);

//   const months = Array.from({ length: 12 }, (_, i) => i + 1); // Months 1 to 12

//   const handleDateSelect = (month) => {
//     const formattedDate = `${year}-${String(month).padStart(2, "0")}`;
//     console.log("Formatted Date datefilter:", formattedDate); // 확인용 로그

//     onSelectDate(formattedDate);
//     setPopupVisible(false);
//   };

//   const handleYearChange = (direction) => {
//     setYear((prevYear) => {
//       const newYear = prevYear + direction;
//       return newYear >= 1990 && newYear <= 2200 ? newYear : prevYear;
//     });
//   };

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (
//         popupRef.current && 
//         !popupRef.current.contains(event.target) && 
//         !buttonRef.current.contains(event.target)
//       ) {
//         setPopupVisible(false);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   const formatDateToKorean = (dateString) => {
//     if (!dateString || typeof dateString !== "string") {
//       throw new Error("Invalid date string");
//     }
  
//     const [year, month] = dateString.split("-");
    
//     if (!year || !month) {
//       throw new Error("Invalid date format. Expected 'YYYY-MM'");
//     }
  
//     const formattedYear = year.slice(-2); // 마지막 두 자리만 사용
//     const formattedMonth = parseInt(month, 10); // 앞에 '0' 제거
    
//     return `${formattedYear}년 ${formattedMonth}월`;
//   }

//   const selected = (selectedDate !== null);

//   return (
//     <div style={{ position: "relative" }}>
//       <button ref={buttonRef} onClick={togglePopup} style={{
//         ...styles.dateFilterButton, 
//         borderColor: selected ? "var(--main-blue_50)": "var(--grayscale-cool_50)"}}
//         >
//         <p className="font-body4-semibold" style={{color: selected ? "var(--main-blue_60" : "var(--text-color_50)" }}>
//           {selected ? formatDateToKorean(selectedDate) : '날짜'}
//         </p>
//         <img src={selected ? assets.icons.calendar_selected : assets.icons.calendar} 
//         style={{width: "16px"}}/>
//       </button>
//       {isPopupVisible && (
//         <div ref={popupRef} style={styles.dateFilterBox}>
//           <div style={styles.dateFilterHead}>
//             <div style={styles.dateFilterYearButton} onClick={() => handleYearChange(-1)}>
//               <assets.icons.chevron_left style={{ color: "var(--grayscale-cool_60" }}/>
//             </div>              

//             <div style={styles.dateFilterYear}>
//               <img src={assets.icons.calendar} style={{width: "20px"}}/>
//               <h3 className="font-body1-semibold">{year}</h3>
//             </div>

//             <div style={styles.dateFilterYearButton} onClick={() => handleYearChange(1)}>
//               <assets.icons.chevron_right style={{ color: "var(--grayscale-cool_60" }}/>
//             </div>  

//           </div>
//           <div style={styles.dateFilterMonthBox}>
//             {months.map((month) => (
//               <button
//                 className="font-body2-semibold"
//                 key={month}
//                 onClick={() => handleDateSelect( month )}
//                 style={styles.dateFilterMonth}
//               >
//                 {month}월
//               </button>
//             ))}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

const BoardTypeBadge = ({boardTypeKey, boardTypeList})=>{
  const boardType = boardTypeList.find(cat => cat.key === boardTypeKey);

  return boardType ? (
    <div
      style={{
        ...styles.boardTypeBadge,
        color: boardType.textColor,
        backgroundColor: boardType.badgeColor
      }}
      className="font-body4-semibold"
    >
      {boardType.label}
    </div>
  ) : (
    <div style={styles.boardTypeBadge} className="font-body4-semibold">
      알 수 없음
    </div>
  );
}

const CommuteAlarmBox = ({readyState, rowId}) =>{
  const handleClickAlarm = () => {
    if (readyState) {
      // alert(rowId); // readyState가 true일 때만 실행
      // console.log('clicked_id is: ', rowId);
      alert('준비중인 기능입니다.');
    }
  };

  return (
    <div style={{...styles.commuteAlarmBox,
      cursor: readyState ? "pointer" : "default",
      backgroundColor : readyState ? "white" : "var(--grayscale-cool_40)",
      border: readyState ? "1px solid var(--primary-crimson_60)" : "0px",
    }} onClick={handleClickAlarm}>
      <p className="font-body4-semibold" style={{
        color: readyState ? "var(--primary-crimson_60)" : "var(--text-color_50)",
      }}>알림 보내기</p>
      <assets.icons.alarm style={{color: readyState ? "var(--primary-crimson_60)" : "#888689"}}/>
    </div>
  )
}

const cellWidthStyler = (key) =>{
  switch (key) {
    case "boardNetworkCategory":
      return { width: "120px", textAlign: "start"}; // ✅ "분류" 열
    case "company":
      return {maxWidth: "150px"};
    case "id":
      return { width: "70px",}; // ✅ "순번" 열
    case "_id":
      return {display: 'none'};
    case "title":
      return { textAlign: "start"}
    case "commute_alarm":
      return { width : "183px", height: "56px"}
    default:
      return {}; // ✅ 기본 스타일
  }
}

const filterButton = {
  border: "1px solid var(--grayscale-cool_50)",
  borderRadius: "4px",
  height: "45px",
  display:"flex",
  justifyContent: "center",
  alignItems: "center",
  gap: "10px",
  padding:"8px 16px",
  backgroundColor: "white",
  cursor: "pointer",
}

const filterBox ={
  position: "absolute",
  boxSizing: "border-box",
  top: "calc(100% + 10px)",
  left: 0,
  background: "white",
  border: "1px solid #ddd",
  borderRadius: "8px",
  boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.30), 0px 2px 6px 2px rgba(0, 0, 0, 0.15)",
  zIndex: 1000,
}

const styles={
  
  mainTable:{
    width: '100%',
    borderCollapse: 'collapse', 
    border: "0px",
    borderRadius: "20px 20px 0px 0px",
    overflow: "hidden",
    marginBottom: "40px"
  },
  mainTableHead:{
    backgroundColor: "var(--grayscale_20)",
    border: "0px",
    textAlign: "center",
    padding: "10px 12px",
    height: "44px",
    boxSizing: "border-box"
  },
  mainTableContents:{
    border: "0px",
    textAlign: "center",
    height: "44px",
    boxSizing: "border-box",
    borderBottom: "1px solid var(--grayscale-cool_20)",
  },
  metaBallMenu: {
    position: "fixed", // ✅ 뷰포트 기준 위치 지정
    // position: "absolute", 
    // top: "40px", left: "-120px",
    background: "white", borderRadius:"8px", zIndex: "999",
    display:"flex", flexDirection: "column", alignItems:"flex-start",
    boxShadow: "0px 4px 8px 0px rgba(157, 163, 191, 0.20)"
  },
  metaBallMenuItem:{
    height:"45px", display:"flex", alignItems:"center", justifyContent: "flex-start", gap:"20px", padding: "12px 16px",
    borderBottom: "1px solid var(--grayscale-cool_20)", backgroundColor:"white", cursor:"pointer", color:"var(--text-color_50)", boxSizing:"border-box"
  },

  boardTypeBadge:{
    display:"flex",
    alignItems:"center",
    justifyContent: "center",
    borderRadius: "16px",
    padding:"2px 12px",
    width: "fit-content",
  },

  // dateFilterButton
  
  dateFilterButton:{
    ...filterButton,
  },
  dateFilterBox:{
    ...filterBox,
    width: "360px",
  },
  dateFilterHead:{
    display: "flex",
    alignItems: "center",
    width: "100%",
    boxSizing: "border-box",
    justifyContent: "space-between",
    height: "60px",
    padding: "16px",
    borderBottom: "1px solid var(--grayscale-cool_20)",
  },
  dateFilterYearButton:{
    display: "flex",
    width: "28px",
    height: "28px",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "8px",
    border: "1px solid var(--grayscale-cool_40)",
    cursor: "pointer",
  },
  dateFilterYear:{
    display:"flex",
    alignItems: "center",
    gap: "12px",
  },
  dateFilterMonthBox:{
    display:"flex",
    padding:"8px 20px 20px 20px",
    gap:"12px",
    flexWrap: "wrap",
    width: "100%",
    boxSizing: "border-box",
    justifyContent: "center"
  },
  dateFilterMonth:{
    background: "white",
    cursor: "pointer",
    width: "70px",
    height: "95px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    border: "none",
    color: "var(--text-color_60)",
  },

  //categoryFilterButton

  categoryFilterButton:{
    ...filterButton,
  },
  categoryFilterBox:{
    ...filterBox,
  },
  categoryItem:{
    minWidth: "102px",
    padding: "16px 20px 16px 16px",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    borderBottom: "1px solid var(--grayscale-cool_20)",
    cursor: "pointer",
  },

  //commute Alarm Box
  commuteAlarmBox: {
    width: "109px", height: "36px", borderRadius: "4px", margin: "auto",
    display: "flex", gap: "8px", alignItems: "center", justifyContent: "center", boxSizing: "border-box"
  }
}


export default MainTable;